export enum FeedActionType {
    Voucher,
    Poll
}